import { Button } from "reactstrap";
import { CommonHeader } from "../../../components/commons";

const RaiseExpenseHome = () => {
  return (
    <>
      <div className="d-flex justify-content-between align-items-center">
        <div>
          <CommonHeader title="Raise Expense" />
        </div>
        <div style={{ display: "flex" }}>
          <div className="ml-4" style={{ marginTop: "-10px" }}>
            <button className="btn btn-outline" onClick={() => {}}>
              + New Expense
            </button>
          </div>
          <div className="ml-4" style={{ marginTop: "-10px" }}>
            <button className="btn btn-primary" onClick={() => {}}>
              + New Expense Report
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default RaiseExpenseHome;
